import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/modalConfirm.css';
import { Button, Fab, CircularProgress } from '@material-ui/core';
import { ArrowNarrowLeft, LetterX } from 'tabler-icons-react';

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles((theme) => ({
    paper: {
        position: 'absolute',
        width: 'clamp(320px, 55vw, 760px)',
        backgroundColor: theme.palette.background.paper,
        borderRadius: 3,
        boxShadow: theme.shadows[2],
    },
}));

export default function ModalConfirm() {
    const {
        openConf,
        setOpenConf,
        colorB,
        selectParo,
        mensajeConf,
        textC,
        setOpenM,
        setOpenP,
        isCall,
        realiLlamada,
        callInProgress,
        actualizarParo,
    } = useGeneral();
    const classes = useStyles();
    // getModalStyle is not a pure function, we roll the style only on the first render
    const [modalStyle] = React.useState(getModalStyle);

    const handleCloseAll = () => {
        setOpenM(false);
        setOpenP(false);
        setOpenConf(false);
    };

    const handleClose = () => {
        setOpenConf(false);
        setOpenM(true);
    };

    const body = (
        <div style={modalStyle} className={`${classes.paper} modal-appear-animated`}>
            <div className="modalConf-head" style={{ backgroundColor: colorB }}>
                <Fab
                    onClick={handleClose}
                    style={{ backgroundColor: 'rgba(255,255,255,0.22)', boxShadow: 'none' }}
                >
                    <ArrowNarrowLeft size={30} color={'#ffffff'} />
                </Fab>
                <div className="modalConf-text" style={{ color: textC }}>
                    <h4 className="modalConf-text-field">{selectParo}</h4>
                </div>
                <div className="modalConf-exit">
                    <LetterX
                        size={22}
                        color={'#ffffff'}
                        onClick={handleCloseAll}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
            <div className="modalConf-body">
                <div className="modalConf-body-text">
                    <h1>
                        Estás seguro de {mensajeConf} "{selectParo}"
                    </h1>
                </div>
                <div className="modalConf-body-buttons">
                    <div
                        className="modalConf-body-buttons-first"
                        style={{
                            display: isCall ? 'none' : 'flex',
                        }}
                    >
                        <Button
                            className="modalM-body-buttonS"
                            style={{ backgroundColor: colorB }}
                            disabled={callInProgress}
                            onClick={(e) => realiLlamada()}
                        >
                            {callInProgress ? (
                                <CircularProgress size={28} style={{ color: textC }} />
                            ) : (
                                <h1 style={{ color: textC }}>Confirmar</h1>
                            )}
                        </Button>
                    </div>
                    <div
                        className="modalConf-body-buttons-first"
                        style={{
                            display: isCall ? 'flex' : 'none',
                        }}
                    >
                        <Button
                            className="modalM-body-buttonS"
                            style={{ backgroundColor: colorB }}
                            onClick={(e) => actualizarParo()}
                        >
                            <h1 style={{ color: textC }}>Confirmar</h1>
                        </Button>
                    </div>
                    <div className="modalConf-body-buttons-second">
                        <Button
                            className="modalM-body-buttonC"
                            style={{
                                borderRadius: '3px',
                                borderWidth: '2px',
                                borderStyle: 'solid',
                                borderColor: colorB,
                            }}
                            onClick={(e) => handleClose()}
                        >
                            <h1>Cancelar</h1>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div>
            <Modal
                open={openConf}
                onClose={handleClose}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
}
